/* eslint-disable no-unused-vars */
import { message } from '@whalecloud/fdx';
// import { delay } from 'redux-saga';
import { login, getRegdtls, updateKYCdetails, listKYCdetails, updateProposaldetails, addMember, listMembers } from '@/services/fmApplicant';

const sampleApplicant = {
  regId: '12345',
  regDate: new Date('2023-06-15').toISOString(),
  username: 'john_doe',
  password: 'encrypted_password',
  firmName: 'Doe Enterprises',
  surname: 'Doe',
  name: 'John',
  dob: new Date('1980-01-01').toISOString(),
  address1: '123 Main Street',
  address2: 'Suite 456',
  city: 'Metropolis',
  state: 'NY',
  postalCode: '12345',
  email: 'john.doe@example.com',
  fax: '123-456-7890',
  home: '123-456-7890',
  mobile: '098-765-4321',
  website: 'http://www.doeenterprises.com',
  zone: 'Zone A',
  circle: 'Circle B',
  ssa: 'SSA C',
  startDate: '2023-01-01',
  endDate: '2024-01-01',
  fmsRemarks: 'Remarks here',
  franchiseeManagerUsername: 'manager123',
  proposalStatus: 'Approved',
  bankAccountName: 'John Doe',
  bankAccountNo: '9876543210',
  ifscCode: 'IFSC1234',
  panNo: 'ABCDE1234F',
  tinNo: 'TIN1234567',
  vat: 'VAT1234567',
  vendorCode: 'Vendor123',
  emailValidated: 'true',
  docStatus: 'Complete',
  partnerType: 'Type A',
  firmType: 'Self help group',
  block: 'Block 1',
  gp: 'GP 2',
  district: 'District 3',
  members: 5,
  mainLocality: 'Locality 4',
  pulledByDscm: 'false',
  agreementStatus: 'Active',
  agreementStartDate: new Date('2023-01-01').toISOString(),
  agreementEndDate: new Date('2024-01-01').toISOString(),
};

const sampleApplicants = [{
  regId: '12345',
  regDate: new Date('2023-06-15').toISOString(),
  username: 'john_doe',
  password: 'encrypted_password',
  firmName: 'Doe Enterprises',
  surname: 'Doe',
  name: 'John',
  dob: new Date('1980-01-01').toISOString(),
  address1: '123 Main Street',
  address2: 'Suite 456',
  city: 'Metropolis',
  state: 'NY',
  postalCode: '12345',
  email: 'john.doe@example.com',
  fax: '123-456-7890',
  home: '123-456-7890',
  mobile: '098-765-4321',
  website: 'http://www.doeenterprises.com',
  zone: 'Zone A',
  circle: 'Circle B',
  ssa: 'SSA C',
  startDate: '2023-01-01',
  endDate: '2024-01-01',
  fmsRemarks: 'Remarks here',
  franchiseeManagerUsername: 'manager123',
  proposalStatus: 'Approved',
  bankAccountName: 'John Doe',
  bankAccountNo: '9876543210',
  ifscCode: 'IFSC1234',
  panNo: 'ABCDE1234F',
  tinNo: 'TIN1234567',
  vat: 'VAT1234567',
  vendorCode: 'Vendor123',
  emailValidated: 'true',
  docStatus: 'Complete',
  partnerType: 'Type A',
  firmType: 'Sole Proprietorship',
  block: 'Block 1',
  gp: 'GP 2',
  district: 'District 3',
  members: 5,
  mainLocality: 'Locality 4',
  pulledByDscm: 'false',
  agreementStatus: 'Active',
  agreementStartDate: new Date('2023-01-01').toISOString(),
  agreementEndDate: new Date('2024-01-01').toISOString(),
},
{
  regId: '42934823',
  regDate: new Date('2023-06-15').toISOString(),
  username: 'john_doe',
  password: 'encrypted_password',
  firmName: 'Ayyyy Ayyyy',
  surname: 'Doe',
  name: 'John',
  dob: new Date('1980-01-01').toISOString(),
  address1: '123 Main Street',
  address2: 'Suite 456',
  city: 'Metropolis',
  state: 'NY',
  postalCode: '12345',
  email: 'john.doe@example.com',
  fax: '123-456-7890',
  home: '123-456-7890',
  mobile: '098-765-4321',
  website: 'http://www.doeenterprises.com',
  zone: 'Zone A',
  circle: 'Circle B',
  ssa: 'SSA C',
  startDate: '2023-01-01',
  endDate: '2024-01-01',
  fmsRemarks: 'Remarks here',
  franchiseeManagerUsername: 'manager123',
  proposalStatus: 'InProgress',
  bankAccountName: 'John Doe',
  bankAccountNo: '9876543210',
  ifscCode: 'IFSC1234',
  panNo: 'ABCDE1234F',
  tinNo: 'TIN1234567',
  vat: 'VAT1234567',
  vendorCode: 'Vendor123',
  emailValidated: 'true',
  docStatus: 'Complete',
  partnerType: 'Type A',
  firmType: 'Sole Proprietorship',
  block: 'Block 1',
  gp: 'GP 2',
  district: 'District 3',
  members: 5,
  mainLocality: 'Locality 4',
  pulledByDscm: 'false',
  agreementStatus: 'Active',
  agreementStartDate: new Date('2023-01-01').toISOString(),
  agreementEndDate: new Date('2024-01-01').toISOString(),
},
{
  regId: '34892423',
  regDate: new Date('2023-06-15').toISOString(),
  username: 'john_doe',
  password: 'encrypted_password',
  firmName: 'Gib Co',
  surname: 'Doe',
  name: 'John',
  dob: new Date('1980-01-01').toISOString(),
  address1: '123 Main Street',
  address2: 'Suite 456',
  city: 'Metropolis',
  state: 'NY',
  postalCode: '12345',
  email: 'john.doe@example.com',
  fax: '123-456-7890',
  home: '123-456-7890',
  mobile: '098-765-4321',
  website: 'http://www.doeenterprises.com',
  zone: 'Zone A',
  circle: 'Circle B',
  ssa: 'SSA C',
  startDate: '2023-01-01',
  endDate: '2024-01-01',
  fmsRemarks: 'Remarks here',
  franchiseeManagerUsername: 'manager123',
  proposalStatus: 'NotSelected',
  bankAccountName: 'John Doe',
  bankAccountNo: '9876543210',
  ifscCode: 'IFSC1234',
  panNo: 'ABCDE1234F',
  tinNo: 'TIN1234567',
  vat: 'VAT1234567',
  vendorCode: 'Vendor123',
  emailValidated: 'true',
  docStatus: 'Complete',
  partnerType: 'Type A',
  firmType: 'Sole Proprietorship',
  block: 'Block 1',
  gp: 'GP 2',
  district: 'District 3',
  members: 5,
  mainLocality: 'Locality 4',
  pulledByDscm: 'false',
  agreementStatus: 'Active',
  agreementStartDate: new Date('2023-01-01').toISOString(),
  agreementEndDate: new Date('2024-01-01').toISOString(),
},
];

// Sample ResultVO object
const sampleResultVO = {
  returnCode: '200',
  returnMsg: 'success',
  data: sampleApplicant,
};

const sampleResultListVo = {
  returnCode: '200',
  returnMsg: 'success',
  data: sampleApplicants,
};


export default {
  namespace: 'fmApplicant',
  state: {
    isSuccess: undefined,
    memberList: [],
  },


  effects: {
    *login({ payload }, { call, put }) {
      const response = yield call(login, payload);
      // console.log('SampleComponent', sampleResultVO);
      if (response.data) {
        return response.data;
      }
      message.error(response.message || 'Login failed');
      return null;
    },

    *getRegdtls({ payload }, { call, put }) {
      const response = yield call(getRegdtls, payload);
      if (response.data) {
        return response.data;
        // yield put({ type: 'save', payload: { regDetails: response.data } });
      }
      message.error(response.message || 'Failed to get registration details');
      return null;
    },

    *updateKYCdetails({ payload }, { call, put }) {
      try {
        const response = yield call(updateKYCdetails, payload);
        
        if (response?.success) {
          return {
            ...response,
            code: '200',
          };
        }
        return null;
      } catch (error) {
        return null;
      }
    },

    *listKYCdetails({ payload }, { call, put }) {
      try {
        const response = yield call(listKYCdetails, payload);
        if (response.data) {
          return response.data;
          // yield put({ type: 'save', payload: { regDetails: response.data } });
        }
        message.error(response.message || 'Failed to get kyc details');
        return null;
      } catch (error) {
        return null;
      }
    },

    *updateProposaldetails({ payload }, { call, put }) {
      try {
        const response = yield call(updateProposaldetails, payload);
        
        if (response?.success) {
          return {
            ...response,
            code: '200',
          };
        }
        
        return null;
      } catch (error) {
        return null;
      }
    },

    *addMember({ payload }, { call, put }) {
      try {
        const response = yield call(addMember, payload);
        
        if (response?.success) {
          return {
            ...response,
            code: '200',
          };
        }
        
        return null;
      } catch (error) {
        return null;
      }
    },

    *listMembers({ payload }, { call, put }) {
      const response = yield call(listMembers, payload);
      if (response.data) {
        return response.data;
      }
      message.error(response.message || 'Failed to list members');
      return null;
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
